import api from "api";

export const getTasksByType = async (tipoTarefa) => {
  const res = await api.get(`/backoffice/buscarQuantidadeTarefas/${tipoTarefa}`);
  return res.data;
};